import React from 'react';
import { Spinner } from 'react-bootstrap';
import { ListColumn, FooterOptions } from '../Datalist/Datalist'; // Import your Datalist component
import Datalist from '../Datalist/Datalist';
import './CustomerTable.scss';
import { useNavigate } from 'react-router-dom';
import { format } from 'date-fns'; // Import format from date-fns

interface Invoice {
    invoiceNumber: string;
    customerOrgId: string;
    customerName: string; // Add the customerName field
    contractId: string;
    billingDate: string;  // Already in "YYYY-MM-DD" format
    priceExcMoms: number;
    priceIncMoms: number;
}

interface CustomerTableProps {
    invoiceData: Invoice[];
    isLoading: boolean;
}

const CustomerTable: React.FC<CustomerTableProps> = ({ invoiceData, isLoading }) => {

    const navigate = useNavigate(); // Use the navigate hook for navigation

    // Define the columns for the Invoice table
    const columns: ListColumn<Invoice>[] = React.useMemo(() => [
        {
            key: 'invoiceNumber',
            fieldName: 'invoiceNumber',
            name: 'Fakturanummer', // Translated to Swedish
            minWidth: 150,
            isActive: true,
            sorting: true, // Enable sorting
            onRender: (item: Invoice) => item.invoiceNumber,
            footer: (items: Invoice[]) => `Totalt antal Rader: ${items.length}`, // Translated to Swedish
        },
        {
            key: 'customerOrgId',
            fieldName: 'customerOrgId',
            name: 'Kund', // Translated to Swedish
            minWidth: 200,
            isActive: true,
            sorting: true, // Enable sorting
            onRender: (item: Invoice) => `${item.customerName} - ${item.customerOrgId}`, // Display CustomerName - CustomerOrgId
        }
        ,
        {
            key: 'contractId',
            fieldName: 'contractId',
            name: 'Kontrakts-ID', // Translated to Swedish
            minWidth: 150,
            isActive: true,
            sorting: true, // Enable sorting
            onRender: (item: Invoice) => item.contractId,
        },
        {
            key: 'billingDate',
            fieldName: 'billingDate',
            name: 'Fakturadatum', // Translated to Swedish
            minWidth: 150,
            isActive: true,
            sorting: true, // Enable sorting
            onRender: (item: Invoice) => format(new Date(item.billingDate), 'yyyy-MM-dd'), // Format date using date-fns
        },
        {
            key: 'priceExcMoms',
            fieldName: 'priceExcMoms',
            name: 'Pris (Exkl. Moms)', // Translated to Swedish
            minWidth: 150,
            isActive: true,
            sorting: true, // Enable sorting
            onRender: (item: Invoice) => {
                const formattedPrice = new Intl.NumberFormat('sv-SE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(item.priceExcMoms);
                return `${formattedPrice} SEK`;
            },
            footer: (items: Invoice[]) => {
                const total = items.reduce((sum, row) => sum + row.priceExcMoms, 0);
                const formattedTotal = new Intl.NumberFormat('sv-SE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(total);
                return `Totalt: ${formattedTotal} SEK`; // Translated to Swedish
            }
        },
        {
            key: 'priceIncMoms',
            fieldName: 'priceIncMoms',
            name: 'Pris (Inkl. Moms)', // Translated to Swedish
            minWidth: 150,
            isActive: true,
            sorting: true, // Enable sorting
            onRender: (item: Invoice) => {
                const formattedPrice = new Intl.NumberFormat('sv-SE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(item.priceIncMoms);
                return `${formattedPrice} SEK`;
            },
            footer: (items: Invoice[]) => {
                const total = items.reduce((sum, row) => sum + row.priceIncMoms, 0);
                const formattedTotal = new Intl.NumberFormat('sv-SE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(total);
                return `Totalt: ${formattedTotal} SEK`; // Translated to Swedish
            }
        }
    ], [invoiceData]);

    return (
        <div className="customer-table-wrapper" style={{ maxHeight: '600px'}}>
            <Datalist
                items={invoiceData}
                isLoading={isLoading}
                columns={columns}
                setColumns={(updatedColumns: ListColumn<Invoice>[]) => {
                    // console.log('Columns updated:', updatedColumns);
                }}
                initialSortKey="billingDate"  // Set default sort column
                descendingSort={true}    // Set default sort order to descending (most recent first)
                noItemsText="Inga fakturor tillgängliga" // Translated to Swedish
                uniqueKey="invoiceNumber"  // Use 'invoiceNumber' as the unique key
            />
        </div>
    );
};

export default CustomerTable;
